import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	betaBannerText: {
		id: 'jira.dashboard.engagement.banner.beta.text',
		defaultMessage:
			'<a>Atlassian Home dashboards</a> are now in open beta. <b>Opt your site into the platform experiences beta</b> to try them today.',
		description: 'Banner text announcing Home Dashboards open beta availability',
	},
	dismissButtonText: {
		id: 'jira.dashboard.activate-home-dashboards-banner.banner.dismiss.button.text',
		defaultMessage: 'Dismiss',
		description: 'Text for the dismiss button',
	},
});
